<template>
  <UkiModal :modalId="modalId" :title="title" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="new-day-date">Дата</label>
      <input id="new-day-date" type="date" :value="date" @input="$emit('update:date', $event.target.value)" required/>
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal"

export default {
  name: "EditDayModal",
  components: {UkiModal},
  props: ["modalId", "id", "day", "date"],
  emits: ["update:date", "close", "ok"],
  computed: {
    title: function (){
      return !this.id ? 'Новый день' : `Редактирование дня №${this.day}`
    }
  }
}
</script>

<style scoped>

</style>